import { values } from './enums'

const _enum = {
  None: 0,
  Active: 1,
  Closed: 2
}

export const workflowTaskStatus = {
  enumName: 'WorkflowTaskStatus',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/workflowTaskStatus.js